import _t from 'i18n!nls/authentication';

// Get to the const values of any object
type Values<T> = T[keyof T];

export const HAS_PREVIOUSLY_LOGGED_IN = 'has_previously_logged_in';
export const LEARNER_HELP_CENTER_LINK = 'https://learner.coursera.help/hc/articles/209818553';

// SSO Banner Names for tracking
export const SSO_BANNER_NAMES = {
  SOCIAL_LOGIN: 'sso_enforced_via_social_login_banner',
  PASSWORD_LOGIN: 'sso_enforced_via_password_banner',
} as const;

export type SsoBannerName = (typeof SSO_BANNER_NAMES)[keyof typeof SSO_BANNER_NAMES];

export const HEADER_HEIGHT_PX = 55;

export const AUTH_MODES_WITH_SINGLE_PAGE = {
  signup: 'signup',
  login: 'login',
} as const;

export const AUTHENTICATION_MODAL_MODES = {
  COMPLETE: 'complete',
  ERROR: 'error',
  EXPIREDLINK: 'expired',
  FORGOT: 'forgot',
  LINKED: 'linked',
  LOGIN: 'login',
  LOGINCONTINUE: 'logincontinue',
  MAGICLINK: 'magiclink',
  ORGANIZATIONLOGIN: 'organizationlogin',
  ORGANIZATIONSIGNUP: 'organizationsignup',
  REQUESTMAGICLINK: 'requestmagiclink',
  SIGNUP: 'signup',
  SIGNUPCONTINUE: 'signupcontinue',
  SSO: 'sso',
  OPENAIAUTH: 'openaiauth',
} as const;

export type AUTHENTICATION_MODAL_MODES_KEY =
  (typeof AUTHENTICATION_MODAL_MODES)[keyof typeof AUTHENTICATION_MODAL_MODES];

/**
 * Authentication form variant types used to determine which authentication
 * method to display in the authentication modal/flow.
 */
export const AUTHENTICATION_FORM_VARIANTS = {
  /** Traditional email/password authentication form */
  PASSWORD: 'password',
  /** Generic authentication form (fallback/default) */
  GENERIC: 'generic',
  /** Social media and Single Sign-On authentication options */
  SOCIALSSO: 'socialsso',
} as const;

export type AUTHENTICATION_FORM_VARIANTS_KEY =
  (typeof AUTHENTICATION_FORM_VARIANTS)[keyof typeof AUTHENTICATION_FORM_VARIANTS];

export const ALL_THIRD_PARTY_AUTH_SERVICES = {
  apple: 'apple',
  facebook: 'facebook',
  google: 'google',
} as const;

export type ThirdPartyAuthService = Values<typeof ALL_THIRD_PARTY_AUTH_SERVICES>;

export const getThirdPartyAuthServiceNameMapping = () => {
  return {
    [ALL_THIRD_PARTY_AUTH_SERVICES.apple]: _t('Apple'),
    [ALL_THIRD_PARTY_AUTH_SERVICES.facebook]: _t('Facebook'),
    [ALL_THIRD_PARTY_AUTH_SERVICES.google]: _t('Google'),
  };
};

export const DEFAULT_THIRD_PARTY_AUTH_SERVICES: Array<ThirdPartyAuthService> = [
  ALL_THIRD_PARTY_AUTH_SERVICES.google,
  ALL_THIRD_PARTY_AUTH_SERVICES.facebook,
  ALL_THIRD_PARTY_AUTH_SERVICES.apple,
];

export type LoginMethodType = 'password' | 'generic' | ThirdPartyAuthService;
